import { ICoach } from "../models/ICoach";
import { IPagination } from "../models/IPagination";
import api from "../services/api";
import qs from "qs";

export const getCoachById = (id: string): Promise<{ data: ICoach }> => api.get(`Coach/${id}`);

export const deleteCoach = (id: string) => api.delete(`Coach?coachId=${id}`);

export const getCoachList = (
  pageNumber: number,
  pageSize: number,
  search?: string,
  sortBy?: "firstName" | "createdAt" | "nationality" | "gender",
  sortOrder?: "desc" | "asc",
  genderFilter?: string[],
  nationalityFilter?: string[],
  languagesFilter?: string[],
  verifiedFilter?: string
): Promise<{
  data: { items: ICoach[]; pagination: IPagination };
}> => {
  const params: Record<string, any> = {
    pageNumber,
    pageSize,
    sortBy: sortBy || "name",
    sortOrder: sortOrder || "asc",
  };

  if (search) params.search = search;
  if (genderFilter?.length) params.genderFilter = genderFilter;
  if (nationalityFilter?.length) params.nationalityFilter = nationalityFilter;
  if (languagesFilter?.length) params.languageFilter = languagesFilter;
  if (verifiedFilter) params.verifiedFilter = verifiedFilter;

  return api.get("Coach/all", {
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getCoachNationalities = () => api.get("Coach/nationalities");
